import { Button, Modal } from 'antd';
import { Form } from '@/components';
import { useTranslation } from 'react-i18next';
import { SelectTaskTemplateFormValue } from '@/views';
import { SelectTaskTemplateForm } from '@/views';

interface TaskTemplateModalProps {
  title: string;
  onSubmit: (props: SelectTaskTemplateFormValue) => any;
  onClose?: () => any;
  communityId?: string;
  allTypes?: boolean;
}

export function SelectTaskTemplateModal(props: TaskTemplateModalProps) {
  const { title, onSubmit, onClose, communityId, allTypes } = props;
  const { t } = useTranslation();

  return (
    <Modal
      title={title}
      visible
      onCancel={onClose}
      footer={[
        <Button key="back" type="default" onClick={onClose}>
          {t('tasks.details.cancel')}
        </Button>,
        <Form.Submit uid="select-task-template" key="submit" type="primary">
          {t('tasks.details.save')}
        </Form.Submit>,
      ]}
    >
      <SelectTaskTemplateForm
        onSubmit={onSubmit}
        communityId={communityId}
        allTypes={allTypes}
      />
    </Modal>
  );
}
